// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__28Nle","right":"styles_right__27Am2"};